module.exports = __webpack_public_path__ + "static/media/ballet.c5cdfa0a.svg";